export default {
  'Sample photo': '样例图片',
  Removing: '去除中',
  Edit: '编辑',
  'Adjust Picture': '图片调整',
  Restore: '复原',
  Eraser: '橡皮',
  Size: '尺寸',
  Background: '背景',
  Custom: '常用',
  Presets: '预设',
  'Add Image': '添加图片',
  'Scale to Fit': '缩放以合适',
  'Full Width': '全屏宽度',
  'Full Height': '全屏高度',
  Move: '移动',
  Undo: '撤销',
  Redo: '恢复',
  Enlarge: '放大',
  Reduce: '缩小',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw 在线背景去除',
    desc: '轻松移除掉你的照片背景 100%自动和免费',
    imgAlt: 'photo background remover',
    submitBtn: '去除背景',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows": "阴影",
  "Intensity": "强度",
  "Radius": "半径",
  "Color": "颜色",
  "Move": "移动",
  "2D move": "2D移动",
  "3D move": "3D移动",
  "Move the shadow": "在图片中移动阴影",
  "Upload failed, click to try again": "上传失败，点击重试",

};
